
<template>
      <div class="sale-tan">
        <div class="sale-tanpg">
            <div class="sale-tan-box" :class="saletanpgno?'sale-tan-box-no':''">
                <div v-if="!saletanpgno&&!jianglianj" class="sale-tan-con">
                    <div class="sale-num">
                        <p class="p1">
                            ¥<span>{{jiangliadata.prizeMoney}}</span>
                        </p>
                        <p class="p2">{{jiangliadata.fullcutAmountLimit>0&&jiangliadata.fullcutAmountLimit?'满'+jiangliadata.fullcutAmountLimit+'元使用':'不限金额使用'}}</p>
                    </div>
                    <div class="sale-ti">
                        <h5>
                        </h5>
                        <p>{{jiangliadata.expiredStartDate}}-{{jiangliadata.expiredEndDate}}使用</p>
                    </div>
                </div>
                <div v-if="!saletanpgno&&jianglianj" class="sale-tan-xian">
                    <i>{{ifylxd?'奖励金':'鼓励金'}}</i>
                    <h5>¥<span>{{jiangliadata.prizeMoney}}</span></h5>
                    <p>{{jiangliadata.expiredEndDate}} 前失效</p>
                </div>
                <a data-stat="优惠卷去使用"  v-if="!saletanpgno&&!jianglianj" :href="juanlink"></a>
                <a data-stat="奖励金去使用" v-if="!saletanpgno&&jianglianj" @click="usejiangli()" href="javascript:void(0);"></a>
                <div v-if="saletanpgno" class="sale-tan-no" v-html="awardhtml">

                </div>
            </div>
            <a data-stat="关闭奖励弹层" @click="shouxiaokapi(2)" class="rom" href="javascript:void(0);"></a>
        </div>
    </div>
</template>

<script>
export default {
  props:['saletanpgno','jianglianj','jiangliadata','juanlink'],
  data () {
      return {
        award:[
                    '哎呀，你离奖<br>品仅差0.1厘米~',
                    '据说，大喊一声<br>“我要中奖”<br>就能提高中奖率哟~',
                    '不要灰心，！<br>再接再厉',
                    '没抽到？一定<br>是你抽奖姿势不对~',
                    '真遗憾，与<br>大奖擦肩而过~',
                    '下一次一定<br>可以抽中！',
                    '谢谢参与~',
                    '此次的错过是<br>为了下次的相遇~',
                    '真可惜，<br>就差一点点呢~'
                ],
       awardhtml:'谢谢参与~',//没有抽中卡是文案
      }
    },
    created(){
      var m=this;
      if(m.saletanpgno){
          var nu=Math.floor(Math.random() *(m.award.length));
          m.awardhtml=m.award[Math.floor(Math.random() *(m.award.length))];
      }
    }, 
    methods:{
          shouxiaokapi(nu){
              this.$parent.shouxiaokapicha(nu);
          },
          usejiangli(){
              dsBridge.call("generalAction",{"type":"3","ios_action":"US_MyWalletVC::1&& ","android_action":"action&&.ui.MyWalletActivity"})
          }
    } 
}
</script>

<style scoped>
.sale-tan,.ka-box{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    top: 0;
    left:0;
    z-index: 9999;
}
.sale-tan .sale-tanpg{
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 6.21rem;
}
.sale-tan .sale-tan-box{
    height:8.28rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/jianl.png) no-repeat center;
    background-size: 100% 100%;
    padding-top: 1.77rem;
    box-sizing: border-box;
    margin-bottom: .4rem;
}
.sale-tan .sale-tan-box.sale-tan-box-no{
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/jianglino.png) no-repeat center;
    background-size: 100% 100%;
}
.sale-tan .sale-tan-box img{
    display: block;
    height: auto;
    position: absolute;
    width: 58%;
    top: 8%;
    right: 21%;
}
.sale-tan .sale-tan-box.sale-tan-box-no img{
    width: 50%;
    top: 10%;
    right: 25%;
}
.sale-tan .sale-tan-box .sale-tan-con{
    display: block;
    margin: 0 auto;
    width: 60%;
    height: 3.2rem;
    margin-top: .9rem;
    margin-bottom: .6rem;
    position: relative;
}
.sale-tan .sale-tan-box .sale-tan-xian{
    width: 5.36rem;
    height: 3.28rem;
    margin: 0 auto;
    position: relative;
    margin-top: 1.06rem;
    margin-bottom: .68rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/douele/image/tan4.png) no-repeat center;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding-top: .67rem;
}
.sale-tan .sale-tan-box a{
    display: block;
    margin: 0 auto;
        width: 3.28rem;
    height: .98rem;
    
}
.sale-tan .rom{
    display: block;
    margin: 0 auto;
    background: url(//i1.ulecdn.com/i/event/2018/0511/tencele/tan5.png) no-repeat center;
    background-size: 100% 100%;
    width: .86rem;
    height: .86rem;
}
.sale-tan-con .sale-num{
    position: absolute;
    left: 10%;
    width: 80%;
    top: 0;
    height: 64%;
    color: #ef203a;
    font-size: .36rem;
    box-sizing: border-box;
    padding-top: .28rem;
}
.sale-tan-con .sale-num .p1{
    display: block;
    text-align: center;
}
.sale-tan-con .sale-num span{
    font-size: .56rem;
}
.sale-tan-con .sale-num .p2{
    font-size: .2rem;
    color: #ef203a;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
.sale-tan-con .sale-ti{
    position: absolute;
    right: 0;
    width: 100%;
    top: 66%;
    height: 34%;
    box-sizing: border-box;
    padding-top: .2rem;
}
.sale-tan-con .sale-ti h5{
    font-size: .32rem;
    color: #fffc00;
    text-align: center;
    margin-bottom: .1rem;
}
.sale-tan-con .sale-ti h5 i{
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
.sale-tan-con .sale-ti h5 span{
    display: inline-block;
    font-size: .27rem;
    color: #fff;
    font-weight: 600;
    text-align: center;
    background-color: #814aff;
    width: 1.3rem;
    height: .44rem;
    line-height: .44rem;
    border-radius: .12rem;
    margin-bottom: .2rem;
}
.sale-tan-con .sale-ti p{
        font-size: .17rem;
    color: #FFFFE2AE;
    box-sizing: border-box;
    text-align: center;
    line-height: .3rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
.sale-tan-box .sale-tan-xian i{
    position: absolute;
    font-size: .27rem;
    color: #fff;
    font-weight: 600;
    text-align: center;
    background-color: #267af9;
    width: 1.3rem;
    height: .44rem;
    line-height: .44rem;
    border-radius: .12rem;
    right: .4rem;
    top: .36rem;
    border: 1px solid #e6feff;
}
.sale-tan .sale-tan-box .sale-tan-xian h5{
    text-align: center;
    color: #ff8400;
    font-size: .56rem;
}
.sale-tan .sale-tan-box .sale-tan-xian h5 span{
    font-size: 1.32rem;
}
.sale-tan .sale-tan-box .sale-tan-xian p{
    font-size: .24rem;
    color: #fff;
    text-align: center;
}
.sale-tan .sale-tan-box.sale-tan-box-no{
    padding-top: 1.9rem;
}
.sale-tan .sale-tan-box .sale-tan-no{
    display: block;
    margin: 0 auto;
    width: 72%;
    height: 3.2rem;
    margin-top: .5rem;
    margin-bottom: 1.4rem;
    position: relative;
    text-align: center;
    color: #FFFFD388;
    font-size: .42rem;
    padding-top: 1.8rem;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/commont/rewardlayer.vue